var map = {
	"./AVAJANG-Logo-black.png": "5344",
	"./bw-logo.png": "e19f",
	"./gauranteelogo.jpg": "92ac",
	"./greyback.png": "02c0",
	"./photo.svg": "f61d",
	"./powerbank.jpg": "4470",
	"./powerbank2.jpg": "e305",
	"./user.svg": "004f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70d0";